export enum OwnershipAttachmentType {
  Image='Image',
  Passeport = 'Passeport',
  CNIB = 'CNIB',
  Certificat_de_propriete = 'Certificat_de_propriete',
  Justificatif_domicile = 'Justificatif_domicile',
  Autre = 'Autre',
}
